import { FC } from "react";
import { Badge, Box, BoxProps, Grid, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import { CASE_FILE_KIND } from "@shared/models";
import { selectors } from "@containers/Cases/store";
import { CASE_DOCUMENT_KINDS } from "@containers/Cases/constants";
import { useCaseDocumentActions } from "@containers/Cases/hooks";

import CaseDocumentCard from "./CaseDocumentCard";
import CaseDocumentEmptyCard from "./CaseDocumentEmptyCard";

const CaseDocuments: FC<BoxProps> = (props) => {
  const caseObj = useSelector(selectors.getCase());
  const caseDocuments = useSelector(selectors.getCaseDocuments());
  const actions = useCaseDocumentActions(caseObj?.id);

  return (
    <Box
      p={6}
      borderRadius={8}
      boxShadow="0px 4px 13px -1px rgba(45, 54, 86, 0.07), 0px 2px 9px -1px rgba(45, 54, 86, 0.06)"
      {...props}
    >
      <Badge variant="subtle" w="max-content">
        CASE DOCUMENTS
      </Badge>
      <Text mt="10px" mb="18px" maxW="720px" fontSize="14px" lineHeight={1.5} color="brand.emptyStateText">
        Parsed text from each document is saved to its matching fields below. Medical summaries and case notes are
        optional and can be added any time.
      </Text>
      <Grid templateColumns="repeat(auto-fit, minmax(270px, 1fr))" gap="14px">
        {CASE_DOCUMENT_KINDS.map((kind) => {
          const caseDocument = caseDocuments.find((item) => item.kind === kind);

          if (caseDocument) {
            return <CaseDocumentCard key={kind} caseDocument={caseDocument} actions={actions} />;
          }

          return kind === CASE_FILE_KIND.PSR ? null : (
            <CaseDocumentEmptyCard key={kind} kind={kind} onAdd={actions.add?.[kind]} addHint={actions.addHint} />
          );
        })}
      </Grid>
    </Box>
  );
};

export default CaseDocuments;
